import PropTypes from "prop-types";
import "./PageStructure.scss";

const PageHeader = ({ headerText, rightSideComponent, result }) => {
  return (
    <div className="page-structure-header">
      <div className="page-structure-header__right">
        <h2 className="page-structure-header__title">
          {headerText && typeof headerText === "string" ? headerText : ""}
        </h2>
        {result !== null && typeof result === "number" && (
          <p className="font-small-regular page-structure-results-color">
            {result} {result < 1 ? "result" : "results"}
          </p>
        )}
      </div>
      {rightSideComponent ? <div>{rightSideComponent}</div> : null}
    </div>
  );
};

PageHeader.propTypes = {
  headerText: PropTypes.string.isRequired,
  rightSideComponent: PropTypes.node,
  result: PropTypes.number,
};

export default PageHeader;
